import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { BetBuilderTrackingValues } from 'packages/sports/web/app/src/bet-builder/bet-builder-tracking';

type BetslipBarClickAction = 'betslip' | 'my bets' | 'undo';

export interface BetslipBarDisplayMode {
    mode: 'my bets' | 'odds' | BetBuilderTrackingValues.EmbeddedSource;
    badge?: BetBuilderTrackingValues.BetBarBadge | BetBuilderTrackingValues.BetBarPlusBadge;
    eventDetails?: 'undo';
    numberOfLegs: number;
}

export enum BetBarErrorTracking {
    UncombinableSelections = "selections can't be combined",
    AvailabilityChanged = 'availability of bet has changed',
    Undo = 'undo',
}
@Injectable()
export class BetslipBarTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackLoad(displayMode: BetslipBarDisplayMode, modelError?: BetBarErrorTracking): void {
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betting',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'bet bar',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'footer',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: displayMode.mode,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: modelError
                ? modelError
                : displayMode.eventDetails
                  ? displayMode.eventDetails
                  : (displayMode.badge ?? displayMode.mode),
            [trackingConstants.COMPONENT_CONTENT_POSITION]: displayMode.numberOfLegs,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackClick(clickTarget: BetslipBarClickAction, displayMode: BetslipBarDisplayMode) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betting',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'bet bar',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: 'footer',
            [trackingConstants.COMPONENT_LOCATION_EVENT]: displayMode.mode,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: displayMode.numberOfLegs,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: clickTarget === 'betslip' && displayMode.badge ? displayMode.badge : clickTarget,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    componentDisplayMode(
        myBetsVisible: boolean,
        undoVisible: boolean,
        numberOfLegs: number,
        betBuilderBadge = false,
        isMulti = false,
    ): BetslipBarDisplayMode {
        return betBuilderBadge
            ? {
                  mode: BetBuilderTrackingValues.EmbeddedSource,
                  badge: isMulti ? BetBuilderTrackingValues.BetBarPlusBadge : BetBuilderTrackingValues.BetBarBadge,
                  eventDetails: undoVisible ? 'undo' : undefined,
                  numberOfLegs,
              }
            : {
                  mode: myBetsVisible ? 'my bets' : 'odds',
                  eventDetails: undoVisible ? 'undo' : undefined,
                  numberOfLegs,
              };
    }
}
